import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal, Kicker, EASE } from "./motion";
import { Plus, Minus } from "lucide-react";

const faqs = [
  {
    q: "Do we have to replace everything at once?",
    a: "No. Most venues start with Front of House and Back Office, then bring in Node and the rest as it suits their calendar. Bridge makes the switch quiet either way.",
  },
  {
    q: "What happens to our existing menu and data?",
    a: "You hand it to Bridge as a menu or product file and it maps the structure for you, categories, modifiers and all. Nothing gets re-keyed by hand.",
  },
  {
    q: "Does Verlo work if the internet goes down mid service?",
    a: "Yes. Node keeps taking orders and payments offline and syncs everything back the moment you are reconnected. Service does not stop.",
  },
  {
    q: "Is this built for big chains or independents?",
    a: "Independent restaurant groups, gastropubs and hospitality-first venues in the UK. It scales from one room to several, without turning into enterprise software.",
  },
  {
    q: "Who do we call when something goes wrong?",
    a: "One team, ours, who understand restaurants and have worked services. Not a queue that hands you between three vendors.",
  },
  {
    q: "How long does onboarding actually take?",
    a: "Most venues are trading on Verlo the same day. Bridge does the heavy lifting in the background while you carry on.",
  },
  {
    q: "When is Connect available?",
    a: "It is coming. You can join early access from the Connect chapter and we will reach out as it gets closer.",
  },
];

function Item({ item, index }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-verlo/15" data-testid={`faq-item-${index}`}>
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid={`faq-toggle-${index}`}
        className="w-full flex items-center justify-between gap-6 py-7 text-left group"
      >
        <span className="font-display font-light text-xl md:text-2xl text-verlo group-hover:text-brass transition-colors duration-300">
          {item.q}
        </span>
        <span className="text-brass shrink-0">
          {open ? <Minus size={22} /> : <Plus size={22} />}
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: EASE }}
            className="overflow-hidden"
          >
            <p className="pb-8 text-base md:text-lg leading-relaxed text-verlo max-w-2xl">
              {item.a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq"
      className="px-6 md:px-12 py-28 md:py-40 border-t border-verlo/10"
    >
      <div className="mx-auto max-w-[1400px] grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <Reveal>
            <Kicker>Questions</Kicker>
            <h2 className="mt-6 font-display font-light text-4xl md:text-5xl tracking-tight leading-[1.1] text-verlo">
              The things people ask
            </h2>
          </Reveal>
        </div>
        <div className="md:col-span-7 md:col-start-6">
          <Reveal>
            <div className="border-t border-verlo/15">
              {faqs.map((f, i) => (
                <Item key={i} item={f} index={i} />
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
